module.exports = __webpack_public_path__ + "media/images/planning-visit-0ff12f7c83f947c117ae9cc7a4d96eca.svg";